import {Component, OnInit, ViewChild, OnDestroy, TemplateRef} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthService} from 'src/app/service/autenticacao/auth.service';
import {ManifestoService} from 'src/app/service/manifesto/manifesto.service';
import {ReclamacaoService} from 'src/app/service/reclamacao/reclamacao.service';
import {AssuntoService} from 'src/app/service/assunto/assunto.service';
import {DenunciaService} from 'src/app/service/denuncia/denuncia.service';
import {CriticaService} from 'src/app/service/critica/critica.service';
import {ElogioService} from 'src/app/service/elogio/elogio.service';
import {CpeService} from 'src/app/service/cpe/cpe.service';
import {SolicitacaoService} from 'src/app/service/solicitacao/solicitacao.service';
import {InformacaoService} from 'src/app/service/informacao/informacao.service';
import {SugestaoService} from 'src/app/service/sugestao/sugestao.service';
import {ConsultaService} from 'src/app/service/consulta/consulta.service';
import {LgpdService} from 'src/app/service/lgpd/lgpd.service';
import {LaiService} from 'src/app/service/lai/lai.service';
import {PesquisarUsuarioService} from 'src/app/service/usuario/pesquisar-usuario.service';
import {FaleComRhService} from '../../../../../service/fale-com-rh/fale-com-rh.service';
import {PAGINA_HOME_USUARIO_INTERNO, PAGINA_PESQUISA_MANIFESTO_OPERADOR} from 'src/app/tools/URL';
import {FILE_UPLOADER} from 'src/app/componentes/file-uploader/file-uploader.component';
import {MANIFESTO_ENUM} from 'src/app/tools/Manifestos';
import {
  OK_MANIFESTO_ENVIADO,
  OK_MANIFESTO_SALVO,
  ERRO_FORMATO_EMAIL_INVALIDO,
  ERRO_FORMULARIO_INVALIDO,
  MSG_OBG_ASSUNTO,
  MSG_OBG_CLASSIFICACAO,
  MSG_OBG_MUNICIPIO,
  MSG_OBG_CARTORIO,
  MSG_OBG_DESCRICAO,
  MSG_LIMITE_DESCRICAO,
  MSG_OBG_TIPO_JUSTICA,
  MSG_OBG_TIPO_JUSTICA_OPCAO,
  MSG_OBG_NUM_PROCESSO,
  MSG_OBG_NUM_PROCESSO_VALIDO,
  MSG_OBG_TIPO_JUSTICA_OPCAO_ANEXO,
  MSG_POPUP_CONFIRMACAO_DENUNCIA,
  OK_PROTOCOLO_MANIFESTACAO_CODIGO,
  OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO,
  OK_PROTOCOLO_RASCUNHO
} from 'src/app/tools/Mensagens';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {forkJoin} from 'rxjs';
import {ProtocoloService} from 'src/app/service/protocolo/protocolo.service';
import {ManifestoStatusDTO} from 'src/app/entity/ManifestoStatusDTO';
import {ProcessoComponent} from 'src/app/view/manifestos/reclamacao';
import {ClassificacaoComponent} from 'src/app/componentes/classificacao/classificacao.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmWindowComponent} from 'src/app/componentes/confirm-window/confirm-window.component';
import {ReclamacaoVO} from 'src/app/entity/ReclamacaoVO';
import {ResponseHandler} from 'src/app/entity/ResponseHandlerDTO';
import {CpeResponseDTO} from "../../../../../componentes/cpe-operador/dto/CpeResponseDTO";
import {CpeOperadorComponent} from "../../../../../componentes/cpe-operador/cpe-operador.component";
import {
  FaleComRhOperadorComponent
} from "../../../../manifestos/fale-com-rh/fale-com-rh-operador/fale-com-rh-operador.component";
import {LaiOperadorComponent} from "../../../../manifestos/lai/lai-operador/lai-operador.component";

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'cadastro-manifesto-operador',
  templateUrl: './cadastro-manifesto-operador.component.html',
  styleUrls: ['./cadastro-manifesto-operador.component.css']
})
export class CadastroManifestoOperadorComponent implements OnInit, OnDestroy {

  listaUsuarios: any[];
  listaManifestos: any[];
  listaAssuntos: any[];
  dataHoraAbertura: number;
  manifestante: any;
  usuarioExterno: string;
  usuarioSelecionado: any;
  manifestoSelecionado: any;
  assuntoSelecionado;
  tipoJustica: number;
  numeroProcesso: string;
  manifestoEnum: any;
  usuarioExternoBuscado: boolean;
  manifesto: any;
  visualizacao: boolean;
  edicao: boolean;
  header: string;
  username: string;
  status: ManifestoStatusDTO;
  arquivosSalvos: any[];
  alerts: string;
  modalRef: BsModalRef;
  message: string;
  isEnvioManifestacao: boolean;
  mensagemPopUpDenuncia = MSG_POPUP_CONFIRMACAO_DENUNCIA;
  requerente: string = '';
  demandaRecebida: string;
  cpeData: CpeResponseDTO;
  faleComRhData: any;
  laiData: any;
  prioridadePessoaIdosa = false;

  @ViewChild(FILE_UPLOADER, {static: false}) fileUploader;
  @ViewChild(ProcessoComponent, {static: false}) processo: ProcessoComponent;
  @ViewChild(ClassificacaoComponent, {static: false}) classificacao: ClassificacaoComponent;
  @ViewChild(CpeOperadorComponent, {static: false}) cpeOperadorComponent: CpeOperadorComponent;
  @ViewChild(FaleComRhOperadorComponent, {static: false}) faleComRhOperadorComponent: FaleComRhOperadorComponent;
  @ViewChild(LaiOperadorComponent, {static: false}) laiOperadorComponent: LaiOperadorComponent;

  constructor(
    private authService: AuthService,
    private pesquisarUsuarioService: PesquisarUsuarioService,
    private manifestoService: ManifestoService,
    private assuntoService: AssuntoService,
    private reclamacaoService: ReclamacaoService,
    public denunciaService: DenunciaService,
    private criticaService: CriticaService,
    private elogioService: ElogioService,
    private solicitacaoService: SolicitacaoService,
    private informacaoService: InformacaoService,
    private sugestaoService: SugestaoService,
    private consultaService: ConsultaService,
    public lgpdService: LgpdService,
    public laiService: LaiService,
    private protocoloService: ProtocoloService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private builder: FormBuilder,
    public modalService: BsModalService,
    public cpeService: CpeService,
    public faleComRhService: FaleComRhService,
  ) {

    this.manifestoEnum = MANIFESTO_ENUM;
    this.usuarioExternoBuscado = false;
    this.listaUsuarios = [];

    this.manifesto = {
      id: '-'
    };

    this.status = new ManifestoStatusDTO();

    this.manifestante = {
      nome: null,
      email: null,
      cpfcnpj: null,
      dataNascimento: null
    };

    this.header = 'Inclusão de demanda';
    this.visualizacao = this.activatedRoute.snapshot.params.id !== undefined &&
      this.activatedRoute.snapshot.params.tipoManifesto !== undefined;
    this.username = this.authService.usuarioLogado.nome;

  }

  ngOnInit() {

    this.dataHoraAbertura = Date.now();

    this.manifestoService.carregarDados().subscribe(manifestos => {

      this.listaManifestos = manifestos.filter(manifesto => manifesto.numeroOrdem !== '1').sort((a, b) => {

        const aEnumKey = Object.keys(this.manifestoEnum).find(key => this.manifestoEnum[key].id === a.id);
        const bEnumKey = Object.keys(this.manifestoEnum).find(key => this.manifestoEnum[key].id === b.id);

        return this.manifestoEnum[aEnumKey].ordem - this.manifestoEnum[bEnumKey].ordem;

      });

      if (this.visualizacao) {

        this.carregarManifesto(this.activatedRoute.snapshot.params.id, this.activatedRoute.snapshot.params.tipoManifesto);

      } else {

        this.refreshData();

      }

    });

  }

  ngOnDestroy() {

    this.reclamacaoService.reclamacao = this.builder.group(this.reclamacaoService.preencherVo());
    this.denunciaService.denuncia = this.builder.group(this.denunciaService.preencherVo());
    this.criticaService.critica = this.builder.group(this.criticaService.preencherVo());
    this.elogioService.elogio = this.builder.group(this.elogioService.preencherVo());
    this.solicitacaoService.solicitacao = this.builder.group(this.solicitacaoService.preencherVo());
    this.informacaoService.informacao = this.builder.group(this.informacaoService.preencherVo());
    this.sugestaoService.sugestao = this.builder.group(this.sugestaoService.preencherVo());
    this.consultaService.consulta = this.builder.group(this.consultaService.preencherVo());
    this.lgpdService.lgpd = this.builder.group(this.lgpdService.preencherVo());

  }

  refreshData() {

    setInterval(() => {
      this.dataHoraAbertura = Date.now();
    }, 1000);

  }

  cancelar() {

    if (this.visualizacao) {

      this.router.navigate([PAGINA_PESQUISA_MANIFESTO_OPERADOR]);

    } else {

      this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

    }

  }

  excluir() {

    const mensagem = 'Atenção!\nApós a exclusão, o rascunho da manifestação não poderá ser recuperado\n\nConfirma a exclusão do rascunho?';

    if (!confirm(mensagem)) {
      return;
    }

    // Tenta obter o id numérico do manifesto
    let id: any = null;
    if (this.activatedRoute && this.activatedRoute.snapshot && this.activatedRoute.snapshot.params && this.activatedRoute.snapshot.params.id) {
      id = this.activatedRoute.snapshot.params.id;
    } else if (this.manifesto && this.manifesto.id) {
      // manifesto.id pode ser no formato 'X123' ou apenas número; extrai o número final
      const match = (this.manifesto.id + '').toString().match(/(\d+)$/);
      id = match ? match[0] : null;
    }

    if (!id) {
      alert('ID do manifesto não encontrado para exclusão.');
      return;
    }

    // chama o método do serviço ManifestoService para excluir o rascunho
    this.manifestoService.excluirRascunho(id, this.manifestoSelecionado).subscribe((res: any) => {

      try {
        if (!res) {
          throw new Error('Resposta vazia do servidor ao excluir rascunho');
        }

        const hasErrors = Array.isArray(res.errors) && res.errors.length > 0;
        if (hasErrors) {
          const msg = res.errors.join('; ');
          throw new Error(msg);
        }

        //const successMsg = res.data && typeof res.data === 'string' ? res.data : 'Rascunho excluído com sucesso.';
        alert('Rascunho excluído com sucesso.');
        this.router.navigate([PAGINA_PESQUISA_MANIFESTO_OPERADOR]);
      } catch (e) {
        //console.error('Erro ao processar resposta de exclusão', e);
        //alert(e && e.message ? e.message : 'Erro ao excluir rascunho.');
        alert('Erro ao excluir rascunho.');
      }
    }, err => {
      //console.error('Erro ao excluir rascunho', err);
      //const message = err && err.message ? err.message : 'Erro ao excluir rascunho.';
      alert('Erro ao excluir rascunho.');
    });

  }

  setStatus(tipoManifesto, status, idManifesto) {

    this.status = status.id !== null ? status : null;
    this.edicao = status.id === 0;
    this.visualizacao = status === null || status.id > 0;
    const tipoHeader = this.edicao ? 'Edição' : 'Visualização';
    this.header = tipoHeader + ' da manifestação de protocolo ' + tipoManifesto + idManifesto;

  }

  preencheDadosEdicao(manifesto, tipoManifesto, idManifesto) {


    this.username = manifesto.username;
    this.manifestante.nome = manifesto.nome;
    this.manifestante.email = manifesto.email;
    this.dataHoraAbertura = manifesto.dataHoraAbertura;
    this.demandaRecebida = manifesto.demandaRecebida;
    this.prioridadePessoaIdosa = manifesto.prioridadePessoaIdosa === true;

    return this.protocoloService.buscarStatusPorTipoManifestoIdManifesto(tipoManifesto.toUpperCase(), idManifesto);

  }

  preencheDadosEdicaoReclamacao(reclamacao) {

    const { reclamacaoViolencia, ...dadosReclamacao } = reclamacao;
    const formulario = this.reclamacaoService.reclamacao;
    formulario.patchValue(dadosReclamacao);
    if (reclamacaoViolencia != null) {
      formulario.get('reclamacaoViolencia').patchValue(reclamacaoViolencia);
    }
    const classificacoesSalvas = reclamacao.listaClassificacao || [];
    this.reclamacaoService.reclamacao.get('listaClassificacaoCompleta').value
      .filter(classificao => classificacoesSalvas.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
      .map(classificao => classificao.selecionado = true);


    if (this.visualizacao) {

      this.reclamacaoService.reclamacao.get('descricaoReclamacao').disable();
      this.reclamacaoService.reclamacao.get('numeroProcesso').disable();
      this.reclamacaoService.reclamacao.get('comarca').disable();
      this.reclamacaoService.reclamacao.get('vara').disable();
      this.reclamacaoService.reclamacao.get('tipoDeJustica').disable();
      this.reclamacaoService.reclamacao.get('opcaoTipoDeJustica').disable();
      this.reclamacaoService.reclamacao.get('municipio').disable();
      this.reclamacaoService.reclamacao.get('unidadeAux').disable();
      this.reclamacaoService.reclamacao.get('demandaRecebida').disable();

    } else {

      this.reclamacaoService.reclamacao.get('cartorio').enable();

    }

    this.reclamacaoService.reclamacao.get('email').clearValidators();

    if (reclamacao.cartorio) {

      this.reclamacaoService.reclamacao.get('municipio').setValue(reclamacao.cartorio.id.municipio.nome);

      const cartorio = this.reclamacaoService.reclamacao.value.listaCartorio.find(cartorio => cartorio.nomeServico === reclamacao.cartorio.nomeServico);
      this.reclamacaoService.reclamacao.get('cartorio').setValue(cartorio.nomeServico);

    }

    if (classificacoesSalvas.some(classificacao => classificacao.possuiUnidade)) {

      const classificacao = classificacoesSalvas.find(classificacao => classificacao.possuiUnidade);
      const unidade = this.reclamacaoService.reclamacao.value.listaUnidade.find(unidade => unidade.id === classificacao.unidade.id);
      this.reclamacaoService.reclamacao.controls.unidadeAux.setValue(unidade);

    }

    const assuntoSalvo = reclamacao.assunto;
    this.assuntoSelecionado = this.listaAssuntos.find(assunto =>
      String(assunto.id) === String(assuntoSalvo && assuntoSalvo.id) ||
      assunto.value === (assuntoSalvo && assuntoSalvo.value)
    ) || assuntoSalvo;
    this.reclamacaoService.reclamacao.controls.assunto.setValue(this.assuntoSelecionado);

  }

  preencheDadosEdicaoConsulta(consulta) {
    this.consultaService.consulta.patchValue({
      id: consulta.id,
      username: consulta.username,
      dataHoraAbertura: consulta.dataHoraAbertura,
      nome: consulta.nome,
      email: consulta.email,
      assunto: consulta.assunto,
      descricaoConsulta: consulta.descricaoConsulta,
      codigoCNS: consulta.codigoCNS,
      codigoCNSFormatado: consulta.codigoCNSFormatado,
      nomeResponsavelServentia: consulta.nomeResponsavelServentia,
      nomeMunicipioServentia: consulta.nomeMunicipioServentia,
      nomeServentia: consulta.nomeServentia,
      codigoMunicipioServentia: consulta.codigoMunicipioServentia,
      tipoClassificacao: consulta.tipoClassificacao,
      codigoComarca: consulta.codigoComarca,
      demandaRecebida: consulta.demandaRecebida,
      termoDeclaracaoVerdade: consulta.termoDeclaracaoVerdade,
      listaClassificacaoCompleta: consulta.listaClassificacaoCompleta,
      assuntos: consulta.assuntos,
      listaClassificacao: consulta.listaClassificacao,
      files: consulta.files,
      monitoramentoConciliacao: consulta.monitoramentoConciliacao || null
    });

    if (consulta.dadosRequerente) {
      let dadosRequerenteGroup = this.consultaService.consulta.get('dadosRequerente') as FormGroup;
      // Adicionar os controles dinamicamente se ainda não existirem
      if (!dadosRequerenteGroup.get('id')) {
        dadosRequerenteGroup.addControl('id', this.builder.control(null));
        dadosRequerenteGroup.addControl('cpf', this.builder.control(null));
        dadosRequerenteGroup.addControl('nome', this.builder.control(null));
        dadosRequerenteGroup.addControl('telefone', this.builder.control(null));
        dadosRequerenteGroup.addControl('email', this.builder.control(null));
        dadosRequerenteGroup.addControl('funcao', this.builder.control(null));
        dadosRequerenteGroup.addControl('atuacao', this.builder.control(null));
        dadosRequerenteGroup.addControl('arquivo', this.builder.array([]));
      }

      // Preencher os valores
      dadosRequerenteGroup.patchValue({
        id: consulta.dadosRequerente.id,
        cpf: consulta.dadosRequerente.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'),
        nome: consulta.dadosRequerente.nome,
        telefone: this.formatarTelefone(consulta.dadosRequerente.telefone),
        email: consulta.dadosRequerente.email,
        funcao: consulta.dadosRequerente.funcao,
        atuacao: consulta.dadosRequerente.atuacao
      });


      if (consulta.dadosRequerente.arquivo && consulta.dadosRequerente.arquivo.length > 0) {
        const arquivoArray = dadosRequerenteGroup.get('arquivo') as FormArray;
        arquivoArray.clear();

        consulta.dadosRequerente.arquivo.forEach(arquivo => {
          arquivoArray.push(this.builder.control(arquivo));
        });
      }
    }

    if (consulta.listaConciliador && consulta.listaConciliador.length > 0) {
      const listaConciliadorArray = this.consultaService.consulta.get('listaConciliador') as FormArray;
      listaConciliadorArray.clear();
      consulta.listaConciliador.forEach(conciliador => {
        const conciliadorGroup = this.consultaService.criarConciliadorForm();

        conciliadorGroup.patchValue({
          id: conciliador.id,
          cpf: conciliador.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'),
          nome: conciliador.nome,
          telefone: this.formatarTelefone(conciliador.telefone),
          email: conciliador.email,
          funcao: conciliador.funcao,
          atuacao: conciliador.atuacao
        });

        if (conciliador.arquivo && conciliador.arquivo.length > 0) {
          const arquivoArray = conciliadorGroup.get('arquivo') as FormArray;
          arquivoArray.clear();

          conciliador.arquivo.forEach(arquivo => {
            arquivoArray.push(this.builder.control(arquivo));
          });
        }

        listaConciliadorArray.push(conciliadorGroup);
      });
    }

    this.consultaService.consulta.get('listaClassificacaoCompleta').value
      .filter(classificao => consulta.listaClassificacao.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
      .map(classificao => classificao.selecionado = true);

    if (this.visualizacao) {
      //TODO Veriricar a desabilitação de todos os campos que estiverem como editáveis
      this.consultaService.consulta.get('descricaoConsulta').disable();
      this.consultaService.consulta.get('codigoCNS').disable();
      this.consultaService.consulta.get('codigoCNSFormatado').disable();
      this.consultaService.consulta.get('nomeMunicipioServentia').disable();
      this.consultaService.consulta.get('nomeResponsavelServentia').disable();
      this.consultaService.consulta.get('tipoClassificacao').disable();
      this.consultaService.consulta.get('demandaRecebida').disable();

    }

    if (this.consultaService.consulta.get('tipoClassificacao').value > 0) {
      var valorTipoClassificacaoString = this.consultaService.consulta.get('tipoClassificacao').value + '';
      this.consultaService.consulta.get('tipoClassificacao').setValue(valorTipoClassificacaoString);
    }

    this.consultaService.consulta.get('email').clearValidators();
    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === consulta.assunto.id);

  }

  preencheDadosEdicaoCritica(critica) {

    this.criticaService.critica.patchValue(critica);
    this.criticaService.critica.get('listaClassificacaoCompleta').value
      .filter(classificao => critica.listaClassificacao.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
      .map(classificao => classificao.selecionado = true);

    if (this.visualizacao) {

      this.criticaService.critica.get('descricaoCritica').disable();
      this.criticaService.critica.get('municipio').disable();
      this.criticaService.critica.get('demandaRecebida').disable();

    } else {

      this.criticaService.critica.get('cartorio').enable();

    }

    this.criticaService.critica.get('email').clearValidators();

    if (critica.cartorio) {

      this.criticaService.critica.get('municipio').setValue(critica.cartorio.id.municipio.nome);

      const cartoriosFiltrados = this.criticaService.critica.value.listaCartorio
        .filter(cartorio => cartorio.id.municipio.nome === critica.cartorio.id.municipio.nome);

      const cartorio = cartoriosFiltrados.find(cartorio => cartorio.nomeServico === critica.cartorio.nomeServico);
      this.criticaService.critica.get('cartorio').setValue(cartorio.nomeServico);

    }

    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === critica.assunto.id);

  }

  preencheDadosEdicaoInformacao(informacao) {

    this.informacaoService.informacao.patchValue(informacao);
    this.informacaoService.informacao.get('listaClassificacaoCompleta').value
      .filter(classificao => informacao.listaClassificacao.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
      .map(classificao => classificao.selecionado = true);

    if (this.visualizacao) {

      this.informacaoService.informacao.get('descricaoInformacao').disable();
      this.informacaoService.informacao.get('numeroProcesso').disable();
      this.informacaoService.informacao.get('comarca').disable();
      this.informacaoService.informacao.get('vara').disable();
      this.informacaoService.informacao.get('tipoDeJustica').disable();
      this.informacaoService.informacao.get('municipio').disable();
      this.informacaoService.informacao.get('demandaRecebida').disable();

    } else {

      this.informacaoService.informacao.get('cartorio').enable();

    }

    this.informacaoService.informacao.get('email').clearValidators();

    if (informacao.cartorio) {

      this.informacaoService.informacao.get('municipio').setValue(informacao.cartorio.id.municipio.nome);

      const cartorio = this.informacaoService.informacao.value.listaCartorio.find(cartorio => cartorio.nomeServico === informacao.cartorio.nomeServico);
      this.informacaoService.informacao.get('cartorio').setValue(cartorio.nomeServico);

    }

    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === informacao.assunto.id);

  }

  preencheDadosEdicaoSugestao(sugestao) {

    this.sugestaoService.sugestao.patchValue(sugestao);
    this.sugestaoService.sugestao.get('listaClassificacaoCompleta').value
      .filter(classificao => sugestao.listaClassificacao.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
      .map(classificao => classificao.selecionado = true);

    if (this.visualizacao) {

      this.sugestaoService.sugestao.get('descricaoSugestao').disable();
      this.sugestaoService.sugestao.get('demandaRecebida').disable();

    }

    this.sugestaoService.sugestao.get('email').clearValidators();
    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === sugestao.assunto.id);

  }

  preencheDadosEdicaoSolicitacao(solicitacao) {

    this.solicitacaoService.solicitacao.patchValue(solicitacao);
    // Necessário a retirada da população da lista de classificações
    /* this.solicitacaoService.solicitacao.get('listaClassificacaoCompleta').value
      .filter(classificao =>
        solicitacao.listaClassificacao.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
      .map(classificao => classificao.selecionado = true); */

    if (this.visualizacao) {

      this.solicitacaoService.solicitacao.get('descricaoSolicitacao').disable();
      this.solicitacaoService.solicitacao.get('numeroProcesso').disable();
      this.solicitacaoService.solicitacao.get('comarca').disable();
      this.solicitacaoService.solicitacao.get('vara').disable();
      this.solicitacaoService.solicitacao.get('tipoDeJustica').disable();
      this.solicitacaoService.solicitacao.get('demandaRecebida').disable();

    }

    this.solicitacaoService.solicitacao.get('email').clearValidators();
    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === solicitacao.assunto.id);
    //this.assuntoSelecionado = null;
    this.solicitacaoService.solicitacao.get('assunto').setValue(this.assuntoSelecionado);

  }

  preencheDadosEdicaoElogio(elogio) {

    this.elogioService.elogio.patchValue(elogio);
    this.elogioService.elogio.get('listaClassificacaoCompleta').value
      .filter(classificao => elogio.listaClassificacao.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
      .map(classificao => classificao.selecionado = true);

    if (this.visualizacao) {

      this.elogioService.elogio.get('nomeElogiado').disable();
      this.elogioService.elogio.get('descricaoElogio').disable();
      this.elogioService.elogio.get('demandaRecebida').disable();

    }

    this.elogioService.elogio.get('email').clearValidators();
    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === elogio.assunto.id);

  }


  preencheDadosEdicaoCpe(cpe) {
    this.elogioService.elogio.get('email').clearValidators();
    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === cpe.assunto.id);
  }

  preencheDadosEdicaoFaleComRh(faleComRh) {
    this.elogioService.elogio.get('email').clearValidators();
    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === faleComRh.assunto.id);
  }

  preencheDadosEdicaoLai(lai) {
    this.manifestante.nome = lai.nomeUsuarioLogado;
    this.manifestante.email = lai.emailUsuarioLogado;
    this.manifestante.cpfcnpj = lai.cpfUsuarioLogado;
    this.manifestante.dataNascimento = lai.dataNascimentoUsuario;
  }

  preencheDadosEdicaoLgpd(lgpd) {

    // console.log(lgpd)
    // this.lgpdService.lgpd.patchValue(lgpd);
    this.lgpdService.lgpd.controls.nome.setValue(lgpd.nome);
    this.lgpdService.lgpd.controls.cpf.setValue(lgpd.cpf);
    this.lgpdService.lgpd.controls.dataNascimento.setValue(lgpd.dataNascimento);
    this.lgpdService.lgpd.controls.email.setValue(lgpd.email);
    this.lgpdService.lgpd.controls.requerente.setValue(lgpd.requerente);
    // this.lgpdService.lgpd.controls.representanteLegal.setValue(lgpd.representanteLegal);
    if (lgpd.representanteLegal) {
      this.lgpdService.lgpd.controls.representanteLegal.get('nome').setValue(lgpd.representanteLegal.nome);
      this.lgpdService.lgpd.controls.representanteLegal.get('cpf').setValue(lgpd.representanteLegal.cpf);
      this.lgpdService.lgpd.controls.representanteLegal.get('dataNascimento').setValue(lgpd.representanteLegal.dataNascimento);
      this.lgpdService.lgpd.controls.representanteLegal.get('email').setValue(lgpd.representanteLegal.email);
    }
    this.lgpdService.lgpd.controls.demanda.setValue(lgpd.demanda);
    this.lgpdService.lgpd.controls.retorno.setValue(lgpd.retorno);
    this.lgpdService.lgpd.controls.emailRetorno.setValue(lgpd.emailRetorno);
    this.lgpdService.lgpd.controls.endereco.setValue(lgpd.endereco);
    this.lgpdService.lgpd.controls.cep.setValue(lgpd.cep);
    this.lgpdService.lgpd.controls.numeroProcessoSEI.setValue(lgpd.numeroProcessoSEI);
    this.lgpdService.lgpd.controls.descricaoLgpd.setValue(lgpd.descricaoLgpd);

    // Anexos
    this.arquivosSalvos = []
    for (let index = 0; index < lgpd.files.length; index++) {
      this.recuperaAnexos(lgpd.files[index])
    }

    // this.lgpdService.lgpd.get('listaClassificacaoCompleta').value
    //   .filter(classificao => lgpd.listaClassificacao.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
    //   .map(classificao => classificao.selecionado = true);

    if (this.visualizacao) {
      this.lgpdService.lgpd.get('requerente').disable();
      this.lgpdService.lgpd.get('nome').disable()
      this.lgpdService.lgpd.get('cpf').disable()
      this.lgpdService.lgpd.get('dataNascimento').disable()
      this.lgpdService.lgpd.get('email').disable()
      this.lgpdService.lgpd.get('demanda').disable()
      this.lgpdService.lgpd.get('retorno').disable()
      this.lgpdService.lgpd.get('emailRetorno').disable()
      this.lgpdService.lgpd.get('endereco').disable()
      this.lgpdService.lgpd.get('cep').disable()
      this.lgpdService.lgpd.get('identificacaoTitular').disable()
      this.lgpdService.lgpd.get('fotoRequerente').disable()
      this.lgpdService.lgpd.get('documentoLegal').disable()
      this.lgpdService.lgpd.get('descricaoLgpd').disable()
      this.lgpdService.lgpd.get('numeroProcessoSEI').disable()
      this.lgpdService.lgpd.get('descricaoLgpd').disable()
      this.lgpdService.lgpd.controls.representanteLegal.get('nome').disable()
      this.lgpdService.lgpd.controls.representanteLegal.get('cpf').disable()
      this.lgpdService.lgpd.controls.representanteLegal.get('dataNascimento').disable()
      this.lgpdService.lgpd.controls.representanteLegal.get('email').disable()
      this.lgpdService.lgpd.controls.representanteLegal.get('demandaRecebida').disable()
    }

    // this.lgpdService.lgpd.get('email').clearValidators();
    // this.assuntoSelecionado = this.listaAssuntos.find(assunto => {
    //   assunto.id === lgpd.assunto.id
    // });
    this.assuntoSelecionado = this.listaAssuntos[0]

  }

  get getStatus() {

    return this.status === null ? 'Sem informação' : this.status.id + ' - ' + this.status.valor;

  }

  // Insere os anexos nos respectivos campos (Recuperação dos dados)
  recuperaAnexos(file) {
    if (file.nomeArquivo.includes('(RGT)')) {
      this.classificacao.solicitacoesLgpd.RGT = [file]
    } else if (file.nomeArquivo.includes('(RGR)')) {
      this.classificacao.solicitacoesLgpd.RGR = [file]
    } else if (file.nomeArquivo.includes('(CRGT)')) {
      this.classificacao.solicitacoesLgpd.CRGT = [file]
    } else if (file.nomeArquivo.includes('(CRGR)')) {
      this.classificacao.solicitacoesLgpd.CRGR = [file]
    } else if (file.nomeArquivo.includes('(PR)')) {
      this.classificacao.solicitacoesLgpd.PR = [file]
    } else {
      this.arquivosSalvos = [file]
    }
  }

  preencheDadosEdicaoDenuncia(denuncia) {
    if (denuncia.denunciaAssedio == null) {
      delete denuncia.denunciaAssedio;
      delete denuncia.denunciaAssedioHtml;

    }
    if (denuncia.infancia == null) {
      delete denuncia.infancia;
      delete denuncia.infanciaHtml;
    }
    this.denunciaService.denuncia.patchValue(denuncia);
    this.denunciaService.denuncia.get('listaClassificacaoCompleta').value
      .filter(classificao => denuncia.listaClassificacao.some(classificaoPreenchida => classificaoPreenchida.id === classificao.id))
      .map(classificao => classificao.selecionado = true);

    if (this.visualizacao) {

      this.denunciaService.denuncia.get('descricaoDenuncia').disable();
      this.denunciaService.denuncia.get('unidadeAux1').disable();
      this.denunciaService.denuncia.get('unidadeAux2').disable();
      // Deverá ser colocado como disable os campos novos da classificação
      this.denunciaService.denuncia.get('codigoMunicipio').disable();
      this.denunciaService.denuncia.get('codigoCNS').disable();
      this.denunciaService.denuncia.get('localidade').disable();
      this.denunciaService.denuncia.get('demandaRecebida').disable();

    }

    this.denunciaService.denuncia.get('email').clearValidators();
    this.assuntoSelecionado = this.listaAssuntos.find(assunto => assunto.id === denuncia.assunto.id);

    if (denuncia.listaClassificacao.some(classificacao => classificacao.possuiUnidade)) {

      //Verificação da situação do denunciaService

      const listaComUnidade = denuncia.listaClassificacao.filter(c => c.possuiUnidade);
      listaComUnidade.forEach(c => {

        const unidade = this.denunciaService.denuncia.value.listaUnidade.find(unidade => unidade.id === c.unidade.id);
        c.unidade = unidade;

        if (c.descricao === 'Cartórios Extrajudiciais Interior') {

          this.denunciaService.denuncia.get('unidadeAux1').setValue(unidade);

        } else {

          this.denunciaService.denuncia.get('unidadeAux2').setValue(unidade);

        }

      });

    }

    if (this.visualizacao && denuncia.anonimo) {

      this.manifestante.nome = 'SIGILOSO';
      this.manifestante.email = 'SIGILOSO';

    }

  }

  carregarManifesto(idManifesto: number, tipoManifesto: string) {

    this.manifesto.id = MANIFESTO_ENUM[tipoManifesto.toUpperCase()].codigo + idManifesto;
    const manifestoEnum = MANIFESTO_ENUM[tipoManifesto.toUpperCase()];

    this.manifestoSelecionado = this.listaManifestos.find(manifesto => manifesto.id === manifestoEnum.id);

    switch (manifestoEnum.id) {

      case this.manifestoEnum.RECLAMACAO.id: {

        forkJoin({
          assuntos: this.assuntoService.carregarAssuntosPorManifesto(this.manifestoSelecionado),
          reclamacao: this.reclamacaoService.carregarPorId(idManifesto)
        }).subscribe(({assuntos, reclamacao}) => {
            this.listaAssuntos = assuntos;

            this.arquivosSalvos = reclamacao.files;
            this.preencheDadosEdicao(reclamacao, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.RECLAMACAO.codigo, status, idManifesto);
                this.preencheDadosEdicaoReclamacao(reclamacao);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.DENUNCIA.id: {

        this.denunciaService.carregarPorId(idManifesto)
          .subscribe(denuncia => {

            this.arquivosSalvos = denuncia.files;

            this.preencheDadosEdicao(denuncia, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.DENUNCIA.codigo, status, idManifesto);
                this.preencheDadosEdicaoDenuncia(denuncia);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.CRITICA.id: {

        this.criticaService.carregarPorId(idManifesto)
          .subscribe(critica => {

            this.arquivosSalvos = critica.files;

            this.preencheDadosEdicao(critica, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.CRITICA.codigo, status, idManifesto);
                this.preencheDadosEdicaoCritica(critica);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.ELOGIO.id: {

        this.elogioService.carregarPorId(idManifesto)
          .subscribe(elogio => {

            this.arquivosSalvos = elogio.files;

            this.preencheDadosEdicao(elogio, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.ELOGIO.codigo, status, idManifesto);
                this.preencheDadosEdicaoElogio(elogio);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.SOLICITACAO.id: {

        this.solicitacaoService.carregarPorId(idManifesto)
          .subscribe(solicitacao => {

            this.arquivosSalvos = solicitacao.files;

            this.preencheDadosEdicao(solicitacao, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.SOLICITACAO.codigo, status, idManifesto);
                this.preencheDadosEdicaoSolicitacao(solicitacao);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.INFORMACAO.id: {

        this.informacaoService.carregarPorId(idManifesto)
          .subscribe(informacao => {

            this.arquivosSalvos = informacao.files;

            this.preencheDadosEdicao(informacao, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.INFORMACAO.codigo, status, idManifesto);
                this.preencheDadosEdicaoInformacao(informacao);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.SUGESTAO.id: {

        this.sugestaoService.carregarPorId(idManifesto)
          .subscribe(sugestao => {

            this.arquivosSalvos = sugestao.files;

            this.preencheDadosEdicao(sugestao, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.SUGESTAO.codigo, status, idManifesto);
                this.preencheDadosEdicaoSugestao(sugestao);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.CONSULTA.id: {

        forkJoin({
          assuntos: this.assuntoService.carregarAssuntosPorManifesto(this.manifestoSelecionado),
          consulta: this.consultaService.carregarPorId(idManifesto)
        }).subscribe(({assuntos, consulta}) => {

            this.listaAssuntos = assuntos;
            this.arquivosSalvos = consulta.files;

            this.preencheDadosEdicao(consulta, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.CONSULTA.codigo, status, idManifesto);

                this.preencheDadosEdicaoConsulta(consulta);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.LGPD.id: {

        this.lgpdService.carregarPorId(idManifesto)
          .subscribe(lgpd => {

            // this.arquivosSalvos = lgpd.files;

            this.preencheDadosEdicao(lgpd, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {

                this.setStatus(this.manifestoEnum.LGPD.codigo, status, idManifesto);
                this.preencheDadosEdicaoLgpd(lgpd);

              });

          }, err => console.log(err));

        break;

      }

      case this.manifestoEnum.CPE.id: {
        this.cpeService.carregarPorId(idManifesto)
          .subscribe(cpe => {
            this.arquivosSalvos = cpe.documentos;
            this.preencheDadosEdicao(cpe, tipoManifesto, idManifesto)
              .subscribe((status: ManifestoStatusDTO) => {
                this.setStatus(this.manifestoEnum.CPE.codigo, status, idManifesto);
                this.cpeData = cpe;
                this.preencheDadosEdicaoCpe(cpe);
              });
          }, err => console.log(err.error));
        break;
      }

      case this.manifestoEnum.FALE_COM_RH.id: {
        this.faleComRhService.carregarPorId(idManifesto)
          .subscribe(dado => {
            this.arquivosSalvos = dado.anexos;
            if(dado.id === null){
              alert('Manifesto inexistente');
              this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);
            }else{
              this.listaAssuntos = dado.assuntos;
              this.preencheDadosEdicao(dado, tipoManifesto, idManifesto)
                .subscribe((status: ManifestoStatusDTO) => {
                  this.setStatus(this.manifestoEnum.FALE_COM_RH.codigo, status, idManifesto);
                  this.faleComRhData = dado;
                  this.preencheDadosEdicaoFaleComRh(dado);
                });
            }
          }, err => console.log(err.error));
        break;
      }
      case this.manifestoEnum.LAI.id: {
        this.laiService.carregarPorId(idManifesto)
          .subscribe(dado => {
            this.arquivosSalvos = dado.anexos;
            if (dado.id === null) {
              alert('Manifesto inexistente');
              this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);
            } else {
              this.preencheDadosEdicao(dado, tipoManifesto, idManifesto)
                .subscribe((status: ManifestoStatusDTO) => {
                  this.setStatus(this.manifestoEnum.LAI.codigo, status, idManifesto);
                  this.laiData = dado;
                  this.preencheDadosEdicaoLai(dado);
                });
            }
          }, err => console.log(err.error));
        break;
      }
      default: {
        alert('Manifesto inexistente');
        break;
      }

    }

  }

  habilitarEmail(event) {

    if (event.key !== 'Tab') {

      this.usuarioExternoBuscado = false;
      this.usuarioSelecionado = null;
      this.listaUsuarios = [];
      this.prioridadePessoaIdosa = false;

    }

  }

  buscarUsuario() {

    if (this.usuarioExterno.trim()) {

      this.listaUsuarios = [];
      this.usuarioSelecionado = null;
      this.manifestante.nome = null;
      this.manifestante.email = null;
      this.usuarioExternoBuscado = false;
      this.prioridadePessoaIdosa = false;

      this.pesquisarUsuarioService.findByName(this.usuarioExterno).subscribe(usuarios => {

        if (usuarios.length === 1) {

          // this.usuarioExterno
          this.manifestante.nome = usuarios[0].nome;
          this.manifestante.email = usuarios[0].email;
          this.manifestante.cpfcnpj = usuarios[0].cpfcnpj;
          this.manifestante.dataNascimento = usuarios[0].dataNascimento;
          this.usuarioExternoBuscado = true;
          this.prioridadePessoaIdosa = usuarios[0].prioridadePessoaIdosa === true;

        } else {

          this.listaUsuarios = usuarios;

        }

      }, erro => console.log(erro));

    }

  }

  usuarioEscolhido() {

    this.manifestante.nome = this.usuarioSelecionado.nome;
    this.manifestante.email = this.usuarioSelecionado.email;
    this.manifestante.cpfcnpj = this.usuarioSelecionado.cpfcnpj;
    this.manifestante.dataNascimento = this.usuarioSelecionado.dataNascimento;
    this.usuarioExternoBuscado = true;
    this.prioridadePessoaIdosa = this.usuarioSelecionado.prioridadePessoaIdosa === true;

  }

  manifestoEscolhido() {

    this.listaAssuntos = [];
    this.assuntoSelecionado = null;
    this.assuntoService.carregarAssuntosPorManifesto(this.manifestoSelecionado).subscribe(assuntos => this.listaAssuntos = assuntos);

    switch (this.manifestoSelecionado.id) {

      case this.manifestoEnum.RECLAMACAO.id: {

        this.reclamacaoService.carregarDados();

        break;

      }

      case this.manifestoEnum.DENUNCIA.id: {

        this.denunciaService.carregarDadosService();

        break;

      }

      case this.manifestoEnum.CRITICA.id: {

        this.criticaService.carregarDadosService();

        break;

      }

      case this.manifestoEnum.ELOGIO.id: {

        this.elogioService.carregarDadosService();

        break;

      }

      case this.manifestoEnum.SOLICITACAO.id: {

        this.solicitacaoService.carregarDadosService();

        break;

      }

      case this.manifestoEnum.INFORMACAO.id: {

        this.informacaoService.carregarDadosService();

        break;

      }

      case this.manifestoEnum.SUGESTAO.id: {

        this.sugestaoService.carregarDadosService();

        break;

      }

      case this.manifestoEnum.CONSULTA.id: {

        this.consultaService.carregarDadosService();

        break;

      }

      case this.manifestoEnum.LGPD.id: {

        this.lgpdService.carregarDadosService();

        break;

      }

      case this.manifestoEnum.LAI.id: {

        break;

      }

      default: {

        console.log('Manifesto inexistente');

        break;

      }

    }

  }

  assuntoEscolhido() {

    switch (this.manifestoSelecionado.id) {

      case this.manifestoEnum.RECLAMACAO.id: {

        this.reclamacaoService.reclamacao.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.DENUNCIA.id: {

        this.denunciaService.denuncia.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.CRITICA.id: {

        this.criticaService.critica.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.ELOGIO.id: {

        this.elogioService.elogio.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.SOLICITACAO.id: {

        this.solicitacaoService.solicitacao.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.INFORMACAO.id: {

        this.informacaoService.informacao.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.SUGESTAO.id: {

        this.sugestaoService.sugestao.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.CONSULTA.id: {

        this.consultaService.consulta.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.LGPD.id: {

        this.lgpdService.lgpd.controls.assunto.setValue(this.assuntoSelecionado);

        break;

      }

      case this.manifestoEnum.LAI.id: {

        break;

      }

      default: {

        console.log('Manifesto inexistente');

        break;

      }

    }

  }

  formularioValido() {
    if (this.manifestante.nome === '' || this.manifestante.nome === null || this.manifestante.nome === undefined) {
      return false;
    }

    if (this.manifestoSelecionado === null || this.manifestoSelecionado === undefined) {
      return false;
    }
    if (this.manifestoSelecionado.id != this.manifestoEnum.LGPD.id &&
      this.manifestoSelecionado.id != this.manifestoEnum.LAI.id &&
      (this.assuntoSelecionado === null || this.assuntoSelecionado === undefined)) {
      return false;

    }
    if (this.demandaRecebida === '' || this.demandaRecebida === null || this.demandaRecebida === undefined) {
      return false;
    }
    return true;
  }

  salvar(templatePopUp: TemplateRef<any>, isEnviar?) {

    if (this.manifestante.email && !EMAIL_REGEX.test(this.manifestante.email)) {

      alert(ERRO_FORMATO_EMAIL_INVALIDO);

      return;

    }

    if (this.manifestoSelecionado.id === this.manifestoEnum.FALE_COM_RH.id) {
      this.faleComRhOperadorComponent.submit(isEnviar, this.manifestoEnum.FALE_COM_RH);
      return;
    }

    if (this.manifestoSelecionado.id === this.manifestoEnum.CPE.id) {
      this.cpeOperadorComponent.onSubmit(isEnviar, this.manifestoEnum.CPE);
      return;
    }

    if (this.manifestoSelecionado.id === this.manifestoEnum.LAI.id) {
      this.laiOperadorComponent.submit(isEnviar, this.manifestoEnum.LAI);
      return;
    }


    if (this.manifestoSelecionado.id === this.manifestoEnum.RECLAMACAO.id
      //&& this.reclamacaoService.reclamacao.valid
    ) {

      // Realizando as validações da reclamação, segundo o preenchimento de todos os campos
      if (!this.validaCamposReclamacao(this.reclamacaoService.reclamacao)) {
        return;
      }

      this.reclamacaoService.reclamacao.controls.demandaRecebida.setValue(this.demandaRecebida);

      if (this.reclamacaoService.reclamacao.controls.cartorio) {

        const cartorio = this.reclamacaoService.reclamacao.value.listaCartorio
          .find(cartorio => cartorio.nomeServico === this.reclamacaoService.reclamacao.controls.cartorio.value && cartorio.id.municipio.nome === this.reclamacaoService.reclamacao.controls.municipio.value);
        this.reclamacaoService.reclamacao.controls.cartorio.setValue(cartorio);

      }

      // Caso tenha arquivos anexados de processos judiciais, serão incorporados a lista de arquivos com uma tag para ser
      // tratado como um documento diferente dos documentos de anexo padrão, e receber a tipagem correta ao enviar para o SEI. (OS 860)
      var arquivosCunhoDisciplinar: any[];
      if (this.classificacao !== undefined && this.classificacao.processo != null && this.classificacao.processo.arquivosAnexados != null) {
        arquivosCunhoDisciplinar = this.classificacao.processo.arquivosAnexados.mapFilesBase64;
      }

      // Validação de anexos, caso seja Cunho Disciplinar, que só poderá ser feito depois do preenchimento dos arquivos.
      if (this.reclamacaoService.reclamacao.value.opcaoTipoDeJustica == '2') {
        if (!this.validaArquivosAnexoCunhoDisciplinar(this.reclamacaoService.reclamacao, arquivosCunhoDisciplinar)) {
          return;
        }
      }


      const fileUploader = this.fileUploader || this.classificacao.fileUploader;
      this.reclamacaoService.gravarManifestoOperador(this.manifestante, fileUploader.mapFilesBase64, isEnviar, arquivosCunhoDisciplinar)
        .subscribe((responseHandler: ResponseHandler) => {

          this.reclamacaoService.reclamacao.reset();

          //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
          this.manifesto.id = responseHandler.data.id;
          isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifestoEnum.RECLAMACAO.codigo + this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(this.manifestoEnum.RECLAMACAO.codigo + this.manifesto.id));


          this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

        }, erro => console.log(erro));

      return;

    } else if (this.manifestoSelecionado.id === this.manifestoEnum.DENUNCIA.id
      //&& this.denunciaService.denuncia.valid
    ) {

      // Necessário validar neste ponto a Denúncia, antes da chamada do pop up de confirmação
      if (!this.validaCamposDenuncia(this.denunciaService.denuncia)) {
        return;
      }

      this.denunciaService.denuncia.controls.demandaRecebida.setValue(this.demandaRecebida);

      // Deverá ser chamado o Modal de popUp de confirmaçãom utilizando o template que será passado como parâmetro (OS 1102)
      this.isEnvioManifestacao = isEnviar;
      this.openModalPopUp(templatePopUp);

      /*  this.denunciaService.gravarManifestoOperador(this.manifestante, this.fileUploader.mapFilesBase64, isEnviar)
       .subscribe(() => {

         this.denunciaService.denuncia.reset();
         isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
         this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

       }, erro => console.log(erro)); */

      return;

    } else if (this.manifestoSelecionado.id === this.manifestoEnum.CRITICA.id && this.criticaService.critica.valid) {

      this.criticaService.critica.controls.demandaRecebida.setValue(this.demandaRecebida);

      if (this.criticaService.critica.controls.cartorio) {

        const cartorio = this.criticaService.critica.value.listaCartorio
          .find(cartorio => cartorio.nomeServico === this.criticaService.critica.controls.cartorio.value && cartorio.id.municipio.nome === this.criticaService.critica.controls.municipio.value);
        this.criticaService.critica.controls.cartorio.setValue(cartorio);

      }

      this.criticaService.gravarManifestoOperador(this.manifestante, this.fileUploader.mapFilesBase64, isEnviar)
        .subscribe((responseHandler: ResponseHandler) => {

          this.criticaService.critica.reset();
          //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
          this.manifesto.id = responseHandler.data.id;
          isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifestoEnum.CRITICA.codigo + this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(this.manifestoEnum.CRITICA.codigo + this.manifesto.id));
          this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

        }, erro => console.log(erro));

      return;

    } else if (this.manifestoSelecionado.id === this.manifestoEnum.ELOGIO.id && this.elogioService.elogio.valid) {

      this.elogioService.elogio.controls.demandaRecebida.setValue(this.demandaRecebida);

      this.elogioService.gravarManifestoOperador(this.manifestante, this.fileUploader.mapFilesBase64, isEnviar)
        .subscribe((responseHandler: ResponseHandler) => {

          this.elogioService.elogio.reset();
          //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
          this.manifesto.id = responseHandler.data.id;
          isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifestoEnum.ELOGIO.codigo + this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(this.manifestoEnum.ELOGIO.codigo + this.manifesto.id));
          this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

        }, erro => console.log(erro));

      return;

    } else if (this.manifestoSelecionado.id === this.manifestoEnum.SOLICITACAO.id && this.solicitacaoService.solicitacao.valid) {

      this.solicitacaoService.solicitacao.controls.demandaRecebida.setValue(this.demandaRecebida);

      this.solicitacaoService.gravarManifestoOperador(this.manifestante, this.fileUploader.mapFilesBase64, isEnviar)
        .subscribe((responseHandler: ResponseHandler) => {

          this.solicitacaoService.solicitacao.reset();
          //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
          this.manifesto.id = responseHandler.data.id;
          isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifestoEnum.SOLICITACAO.codigo + this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(this.manifestoEnum.SOLICITACAO.codigo + this.manifesto.id));

        }, erro => console.log(erro));

      return;

    } else if (this.manifestoSelecionado.id === this.manifestoEnum.INFORMACAO.id && this.informacaoService.informacao.valid) {

      this.informacaoService.informacao.controls.demandaRecebida.setValue(this.demandaRecebida);

      if (this.informacaoService.informacao.controls.cartorio) {

        const cartorio = this.informacaoService.informacao.value.listaCartorio
          .find(cartorio => cartorio.nomeServico === this.informacaoService.informacao.controls.cartorio.value && cartorio.id.municipio.nome === this.informacaoService.informacao.controls.municipio.value);
        this.informacaoService.informacao.controls.cartorio.setValue(cartorio);

      }

      this.informacaoService.gravarManifestoOperador(this.manifestante, this.fileUploader.mapFilesBase64, isEnviar)
        .subscribe((responseHandler: ResponseHandler) => {

          this.informacaoService.informacao.reset();
          //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
          this.manifesto.id = responseHandler.data.id;
          isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifestoEnum.INFORMACAO.codigo + this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(this.manifestoEnum.INFORMACAO.codigo + this.manifesto.id));

        }, erro => console.log(erro));

      return;

    } else if (this.manifestoSelecionado.id === this.manifestoEnum.SUGESTAO.id && this.sugestaoService.sugestao.valid) {

      this.sugestaoService.sugestao.controls.demandaRecebida.setValue(this.demandaRecebida);

      this.sugestaoService.gravarManifestoOperador(this.manifestante, this.fileUploader.mapFilesBase64, isEnviar)
        .subscribe((responseHandler: ResponseHandler) => {

          this.sugestaoService.sugestao.reset();
          //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
          this.manifesto.id = responseHandler.data.id;
          isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifestoEnum.SUGESTAO.codigo + this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(this.manifestoEnum.SUGESTAO.codigo + this.manifesto.id));

        }, erro => console.log(erro));

      return;

    } else if (this.manifestoSelecionado.id === this.manifestoEnum.CONSULTA.id && this.consultaService.consulta.valid) {

      this.consultaService.consulta.controls.demandaRecebida.setValue(this.demandaRecebida);

      this.consultaService.gravarManifestoOperador(this.manifestante, this.fileUploader.mapFilesBase64, isEnviar)
        .subscribe((responseHandler: ResponseHandler) => {

          this.consultaService.consulta.reset();
          //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
          this.manifesto.id = responseHandler.data.id;
          isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifestoEnum.CONSULTA.codigo + this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(this.manifestoEnum.CONSULTA.codigo + this.manifesto.id));
          this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

        }, erro => console.log(erro));

      return;

    } else if (this.manifestoSelecionado.id === this.manifestoEnum.LGPD.id && this.lgpdService.lgpd.valid) {

      this.lgpdService.lgpd.controls.demandaRecebida.setValue(this.demandaRecebida);

      this.lgpdService.gravarManifestoOperador(this.manifestante,
        this.fileUploader.mapFilesBase64,
        this.classificacao.solicitacoesLgpd.titularDados,
        this.classificacao.solicitacoesLgpd.representanteLegal,
        isEnviar)
        .subscribe((responseHandler: ResponseHandler) => {

          this.lgpdService.lgpd.reset();
          //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
          this.manifesto.id = responseHandler.data.id;
          isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifestoEnum.LGPD.codigo + this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(this.manifestoEnum.LGPD.codigo + this.manifesto.id));

        }, erro => console.log(erro));

      return;

    }


    alert(ERRO_FORMULARIO_INVALIDO);

  }

  validaCamposDenuncia(denuncia: FormGroup) {
    var mensagemErro = this.denunciaService.validaCamposDenunciaService(denuncia);

    if (mensagemErro.length > 0) {
      alert(mensagemErro)
      return false;
    }

    return true;
  }

  validaArquivosAnexoCunhoDisciplinar(reclamacao: FormGroup, arquivosCunhoDisciplinar: any[]) {
    var mensagemErroPrimeiraInstância = this.reclamacaoService.validarRegrasPrimeiraInstânciaService(reclamacao, arquivosCunhoDisciplinar);

    if (mensagemErroPrimeiraInstância.length > 0) {
      alert(mensagemErroPrimeiraInstância);
      return false;
    }

    return true;
  }

  validaCamposReclamacao(reclamacao: FormGroup) {
    var mensagemErro = this.reclamacaoService.validaCamposReclamacaoService(reclamacao);

    if (mensagemErro.length > 0) {
      alert(mensagemErro)
      return false;
    }

    return true;
  }

  responderManifesto() {

    // this.router.navigate([
    //   PAGINA_RESPOSTA_MANIFESTO_OPERADOR,
    //   this.activatedRoute.snapshot.params.tipoManifesto,
    //   this.activatedRoute.snapshot.params.id
    // ]);

  }

  montarPayload(): any {
    const formulario = this.denunciaService.denuncia.getRawValue();
    return this.denunciaService.criarEstruturaTipoDetalhe(formulario);
  }

  // Métodos relacionados a gravação dos dados das manifestações, caso for utilizado pop up de confirmação
  //Gravação da Manifestação de Denunica
  gravarManifestoDenuncia(isEnviar: boolean) {

    this.denunciaService.gravarManifestoOperador(this.manifestante, this.fileUploader.mapFilesBase64, isEnviar)
      .subscribe((responseHandler: ResponseHandler) => {

        this.denunciaService.denuncia.reset();
        //isEnviar ? alert(OK_MANIFESTO_ENVIADO) : alert(OK_MANIFESTO_SALVO);
        this.manifesto.id = responseHandler.data.id;
        isEnviar ? alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(this.manifesto.id)) : alert(OK_PROTOCOLO_RASCUNHO(this.manifesto.id));
        this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

      }, erro => console.log(erro));
  }

  // Métodos do PopUp
  // Método de confirmação do popUp, onde será validado qual tipo de manifestação e suas respectivas formas de tratamento
  confirm(): void {
    //this.message = 'Confirmado';
    // Deverá ser executada toda a lógica de envio/salvar da denúncia
    this.montarPayload();
    if (this.manifestoSelecionado.id === this.manifestoEnum.DENUNCIA.id && this.denunciaService.denuncia.valid) {
      this.gravarManifestoDenuncia(this.isEnvioManifestacao);
    }

    this.modalRef.hide();
  }

  decline(): void {
    //this.message = 'Cancelado';
    this.modalRef.hide();
  }

  openModalPopUp(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }

  private formatarTelefone(telefone: string): string {
    if (!telefone) return '';

    const apenasNumeros = telefone.replace(/\D/g, '');

    if (apenasNumeros.length === 10) {
      return apenasNumeros.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    if (apenasNumeros.length === 11) {
      return apenasNumeros.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    return telefone;
  }


}
